export class CompanyNotProvidedException extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CompanyNotProvidedException'
  }
}
